"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable default-case */
var exceljs_1 = __importDefault(require("exceljs"));
var file_saver_1 = require("file-saver");
function exportData(rows, columns) {
    var workbook = new exceljs_1.default.Workbook();
    var worksheet = workbook.addWorksheet('WorkSheet');
    worksheet.columns = columns.map(function (column) { return ({
        header: column.title,
        key: column.props[0],
    }); });
    worksheet.addRows(rows);
    console.log(rows);
    workbook.xlsx.writeBuffer().then(function (data) {
        var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        file_saver_1.saveAs(blob, 'spreadsheet.xlsx');
    });
}
exports.default = exportData;
//# sourceMappingURL=excel.js.map